var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFnLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 4,
    fill: "#80DDCD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.67578 12.7186C5.755 12.0331 8.04081 11.0144 10.9094 12.1984C14.9396 13.8618 18.1706 13.9351 21.0528 10.7476",
    fill: "#80DDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67578 12.7186C5.755 12.0331 8.04081 11.0144 10.9094 12.1984C14.9396 13.8618 18.1706 13.9351 21.0528 10.7476",
    stroke: "#191938"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.67578 17.7553V7.24365V17.7553Z",
    fill: "#80DDCD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.67578 17.7553V7.24365",
    stroke: "#191938",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.418 17.7553C10.418 17.5426 10.418 16.5869 10.418 14.8881C10.418 13.1894 10.418 10.6412 10.418 7.24365",
    fill: "#80DDCD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.418 17.7553C10.418 17.5426 10.418 16.5869 10.418 14.8881C10.418 13.1894 10.418 10.6412 10.418 7.24365",
    stroke: "#191938",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.35068 6.50622C5.35068 6.91353 5.04828 7.24388 4.67542 7.24388C4.3024 7.24388 4 6.91353 4 6.50622C4 6.09873 4.3024 5.76855 4.67542 5.76855C5.04828 5.76855 5.35068 6.09873 5.35068 6.50622Z",
    fill: "#80DDCD",
    stroke: "#191938",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0919 18.493C11.0919 18.9005 10.7895 19.2307 10.4166 19.2307C10.0436 19.2307 9.74121 18.9005 9.74121 18.493C9.74121 18.0855 10.0436 17.7554 10.4166 17.7554C10.7895 17.7554 11.0919 18.0855 11.0919 18.493Z",
    fill: "#80DDCD",
    stroke: "#191938",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1553 17.7558V7.24414V17.7558Z",
    fill: "#80DDCD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1553 17.7558V7.24414",
    stroke: "#191938",
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8336 6.50622C16.8336 6.91353 16.5313 7.24388 16.1582 7.24388C15.7852 7.24388 15.4829 6.91353 15.4829 6.50622C15.4829 6.09873 15.7852 5.76855 16.1582 5.76855C16.5313 5.76855 16.8336 6.09873 16.8336 6.50622Z",
    fill: "#80DDCD",
    stroke: "#191938",
    strokeWidth: 0.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFnLinkIcon);
export default __webpack_public_path__ + "static/media/fn-link-icon.8fb767276ff53cbacd42b2e8063c88a2.svg";
export { ForwardRef as ReactComponent };